import { render, staticRenderFns } from "./MoreFilters.vue?vue&type=template&id=2344ab24&scoped=true"
import script from "./MoreFilters.vue?vue&type=script&lang=js"
export * from "./MoreFilters.vue?vue&type=script&lang=js"
import style0 from "./MoreFilters.vue?vue&type=style&index=0&id=2344ab24&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2344ab24",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VMenu,VSpacer})
